import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_CLAIM_ADJUSTMENT_CODES = 'FETCH_CLAIM_ADJUSTMENT_CODES';
export const FETCH_CLAIM_ADJUSTMENT_CODES_SUCCESS = 'FETCH_CLAIM_ADJUSTMENT_CODES_SUCCESS';
export const FETCH_CLAIM_ADJUSTMENT_CODES_FAIL = 'FETCH_CLAIM_ADJUSTMENT_CODES_FAIL';
export const CLEAR_CLAIM_ADJUSTMENT_CODES = 'CLEAR_CLAIM_ADJUSTMENT_CODES';
export const UPDATE_CLAIM_ADJUSTMENT_CODE = 'UPDATE_CLAIM_ADJUSTMENT_CODE';
export const UPDATE_CLAIM_ADJUSTMENT_CODE_SUCCESS = 'UPDATE_CLAIM_ADJUSTMENT_CODE_SUCCESS';
export const UPDATE_CLAIM_ADJUSTMENT_CODE_FAIL = 'UPDATE_CLAIM_ADJUSTMENT_CODE_FAIL';

// Reducer
export default function claimAdjustmentCodesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_CLAIM_ADJUSTMENT_CODES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_CLAIM_ADJUSTMENT_CODES_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading > 0 ? state.loading - 1 : 0 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_CLAIM_ADJUSTMENT_CODES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_CLAIM_ADJUSTMENT_CODES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case UPDATE_CLAIM_ADJUSTMENT_CODE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchClaimAdjustmentCodes(payload) {
  return { type: FETCH_CLAIM_ADJUSTMENT_CODES, payload };
}

export function fetchClaimAdjustmentCodesSuccess(payload) {
  return { type: FETCH_CLAIM_ADJUSTMENT_CODES_SUCCESS, payload };
}

export function fetchClaimAdjustmentCodesFail(payload) {
  return { type: FETCH_CLAIM_ADJUSTMENT_CODES_FAIL, payload };
}

export function clearClaimAdjustmentCodes(payload) {
  return { type: CLEAR_CLAIM_ADJUSTMENT_CODES, payload };
}

export function updateClaimAdjustmentCode(payload) {
  return { type: UPDATE_CLAIM_ADJUSTMENT_CODE, payload };
}

export function updateClaimAdjustmentCodeSuccess(payload) {
  return { type: UPDATE_CLAIM_ADJUSTMENT_CODE_SUCCESS, payload };
}

export function updateClaimAdjustmentCodeFail(payload) {
  return { type: UPDATE_CLAIM_ADJUSTMENT_CODE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchClaimAdjustmentCodes(payload) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = payload
    ? abortableCallApi(`claim_md/era_adjustment_const/?limit=${payload.limit}&offset=${payload.offset}`)
    : abortableCallApi('claim_md/era_adjustment_const/');
  abort = request.abort;
  return request.res;
}

export function requestSearchClaimAdjustmentCodes({ limit, offset, filters }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('claim_md/era_adjustment_const/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Code',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestUpdateClaimAdjustmentCode(payload) {
  return callApi('claim_md/era_adjustment_const/', 'PATCH', payload);
}

// Sagas
function* fetchClaimAdjustmentCodesSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchClaimAdjustmentCodes, action.payload)
      : yield call(requestFetchClaimAdjustmentCodes, action.payload);
    yield put(fetchClaimAdjustmentCodesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchClaimAdjustmentCodesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* updateClaimAdjustmentCodeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateClaimAdjustmentCode, values);
    yield put(updateClaimAdjustmentCodeSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Claim Code successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateClaimAdjustmentCodeFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* claimAdjustmentCodesSaga() {
  yield takeLatest(FETCH_CLAIM_ADJUSTMENT_CODES, fetchClaimAdjustmentCodesSaga);
  yield takeEvery(UPDATE_CLAIM_ADJUSTMENT_CODE, updateClaimAdjustmentCodeSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/claimAdjustmentCodes.js